export default (() => {
  // Setup constants.
  const FONT_FACTOR_MAX = 5;
  const FONT_FACTOR_MIN = -2;
  const NAME = 'accessibility-font-size';
  const COOKIE = document.documentElement.getAttribute('data-namespace') + NAME;

  // Setup state.
  let fontFactor = 0;

  // Setup style element.
  const styleElement = window.document.createElement('style');
  styleElement.setAttribute('data-source', NAME);
  window.document.head.appendChild(styleElement);

  // Define private methods.
  const updateFontSize = function () {
    let fontSize = 1;
    if (fontFactor === 0) {
      styleElement.innerText = '';
      window.document.body.removeAttribute('data-' + NAME);
    } else {
      // Modify by factor.
      if (fontFactor > 0) {
        fontSize += 1.125 ** fontFactor - 1;
      } else {
        fontSize = 1.125 ** fontFactor;
      }

      // Round to second decimal.
      fontSize = Math.round(fontSize * 10) / 10;
      styleElement.innerText = ':root {font-size:' + fontSize + 'rem;}';
      window.document.body.setAttribute('data-' + NAME, fontFactor);
    }

    // Update in cookies.
    if (window.util && window.util.cookies) {
      if (fontFactor !== 0) {
        window.util.cookies.set(COOKIE, fontFactor);
      } else if (window.util.cookies.has(COOKIE)) {
        window.util.cookies.delete(COOKIE);
      }
    }

    // Dispatch change event.
    window.document.body.dispatchEvent(new CustomEvent('accessibility-font-size-changed', {
      detail: {
        fontSize: fontSize,
        fontFactor: fontFactor
      }
    }));
  };

  // Define public methods.
  const decreaseFontSize = function () {
    if (fontFactor <= FONT_FACTOR_MIN) {
      return;
    }
    fontFactor--;
    if (fontFactor <= FONT_FACTOR_MIN) {
      fontFactor = FONT_FACTOR_MIN;
    }
    updateFontSize();
  };
  const increaseFontSize = function () {
    if (fontFactor >= FONT_FACTOR_MAX) {
      return;
    }
    fontFactor++;
    if (fontFactor >= FONT_FACTOR_MAX) {
      fontFactor = FONT_FACTOR_MAX;
    }
    updateFontSize();
  };
  const resetFontSize = function () {
    if (fontFactor === 0) {
      return;
    }
    fontFactor = 0;
    updateFontSize();
  };

  // Set initial state from cookie.
  if (window.util && window.util.cookies && window.util.cookies.has(COOKIE)) {
    let fontSizeTemp = window.util.cookies.get(COOKIE);
    fontSizeTemp = Number.parseFloat(fontSizeTemp);
    if (!Number.isNaN(fontSizeTemp) && fontSizeTemp % 1 === 0) {
      fontFactor = fontSizeTemp;
      updateFontSize();
    }
  }

  // Make globally available.
  const accessibility = {
    decreaseFontSize: decreaseFontSize,
    increaseFontSize: increaseFontSize,
    resetFontSize: resetFontSize
  };
  if (window.accessibility) {
    window.accessibility = Object.assign(window.accessibility, accessibility);
  } else {
    window.accessibility = accessibility;
  }
});